import { Box, Text, createStyles } from "@mantine/core";

import { MedplumLink, useMedplum } from "@medplum/react";
import { ReactNode, useCallback, useEffect, useState } from "react";

const useStyles = createStyles(() => ({
  main: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  subMain: {
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#262930",
    height: "40px",
    display: "flex",
    flexDirection: "row",
    marginRight: "10px",
    marginTop: "15px",
  },
  children: {
    width: "100%",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
}));
interface DashboaedLayoutProps {
  componentName: string;
  children: ReactNode;
  // length: number;
}

export const DashboardCommonLayout: React.FC<DashboaedLayoutProps> = ({
  componentName,
  children,
  // length,
}) => {
  const { classes } = useStyles();
  return (
    <>
      <Box>
        <Box className={classes.main}>
          <Box className={classes.subMain}>
            <Text sx={{  whiteSpace: "nowrap" }}>
              {componentName}
            </Text>
            {/* <Text>{length}</Text> */}
          </Box>
          <Box className={classes.children}>{children}</Box>
        </Box>
      </Box>
    </>
  );
};
